import { API_CALL } from 'actions/actionConstants'
import type { AppAction } from 'actions/types/ActionTypes'
import { FETCH_LATEST_LOYALTY_ACCOUNT_DETAILS, FETCH_LOYALTY_ACCOUNT } from 'actions/apiActionConstants'
import requestLoyaltyAccount from 'api/loyalty/requestLoyaltyAccount'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import moment from 'moment'

const LOYALTY_ACCOUNT_TTL_IN_SECONDS = 30

interface FetchLoyaltyAccountOptions {
  force?: boolean
}

function fetchLoyaltyAccount(token?: string, options: FetchLoyaltyAccountOptions = {}): AppAction {
  const { force = false } = options
  return (dispatch, getState) => {
    const state = getState()

    if (!getIsLoyaltyEnabled(state)) {
      return
    }

    const hasLoyaltyAccount = getHasLoyaltyAccount(state)
    const loyaltyAccount = state.loyalty.account

    if (force && !loyaltyAccount.fetching) {
      dispatch({
        type: API_CALL,
        api: FETCH_LATEST_LOYALTY_ACCOUNT_DETAILS,
        request: () => requestLoyaltyAccount(token),
      })
      return
    }

    if (
      loyaltyAccount.data?.fetchedAt &&
      moment().utc().diff(moment(loyaltyAccount.data.fetchedAt).utc(), 'seconds') >= LOYALTY_ACCOUNT_TTL_IN_SECONDS
    ) {
      dispatch({
        type: API_CALL,
        api: FETCH_LATEST_LOYALTY_ACCOUNT_DETAILS,
        request: () => requestLoyaltyAccount(),
      })
    }

    if (
      hasLoyaltyAccount ||
      loyaltyAccount.fetching ||
      loyaltyAccount.error
    ) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_LOYALTY_ACCOUNT,
      request: () => requestLoyaltyAccount(token),
    })
  }
}

export default fetchLoyaltyAccount
